/**
 * Animation utilities for consistent component animations
 */

interface SlideUpRevealProps {
    show: boolean;
    translateY?: string;
    maxHeight?: string;
    transitionDuration?: string;
    transitionDelay?: string;
}

/**
 * Generate slide-up reveal animation styles for showing/hiding content
 */
export const getSlideUpRevealStyles = ({
    show,
    translateY = '32px',
    maxHeight = '80px',
    transitionDuration = '0.6s',
    transitionDelay = '0.3s',
}: SlideUpRevealProps): React.CSSProperties => ({
    overflow: 'hidden',
    transform: show ? 'translateY(0px)' : `translateY(${translateY})`,
    opacity: show ? 1 : 0,
    maxHeight: show ? maxHeight : '0px',
    transition: `all ${transitionDuration} ease-out`,
    transitionDelay: show ? transitionDelay : '0s',
});
